import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import get from 'lodash/get';
import { SearchtActionTypes, ServicesDataRequestActionTypes } from '../models/platform-master';

const page_name = 'platformServicesMaster';
interface Service {
  id: string | number;
  service_id: string | number;
  key: number;
  port: number;
  displayName: string;
  type: string | undefined;
}
export interface platformServicesMasterState {
  isPlatformServicesMasterDataLoading: boolean;
  platformServicesMasterData: Array<Service>;
  platformServicesMasterDataTotalCount: number;
  platformServicesMasterDataPageNumber: number;
  platformServicesMasterError: boolean;
  isAddServiceLoading: boolean;
  isAddServiceSuccess: boolean;
  isAddServiceError: boolean;
  isUpdateServiceLoading: boolean;
  isUpdateServiceSuccess: boolean;
  isUpdateServiceError: boolean;
  isRemoveServiceLoading: boolean;
  isRemoveServiceSuccess: boolean;
  isRemoveServiceError: boolean;
  platformMessage: string;
  searchItem: undefined | string;
}

const initialState: platformServicesMasterState = {
  isPlatformServicesMasterDataLoading: false,
  platformServicesMasterData: [],
  platformServicesMasterDataTotalCount: 0,
  platformServicesMasterDataPageNumber: 1,
  platformServicesMasterError: false,
  isAddServiceLoading: false,
  isAddServiceSuccess: false,
  isAddServiceError: false,
  isUpdateServiceLoading: false,
  isUpdateServiceSuccess: false,
  isUpdateServiceError: false,
  isRemoveServiceLoading: false,
  isRemoveServiceSuccess: false,
  isRemoveServiceError: false,
  platformMessage: '',
  searchItem: '',
};

const platformServicesMasterReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getServicesDataRequest: (state, action: ServicesDataRequestActionTypes) => {
      state.isPlatformServicesMasterDataLoading = true;

      state.isAddServiceSuccess = false;
      state.isUpdateServiceSuccess = false;
      state.isRemoveServiceSuccess = false;
    },
    getServicesDataResponse: (state, action) => {
      state.isPlatformServicesMasterDataLoading = false;
      if (state.searchItem === get(action, 'payload.res.search_item', '')) {
        state.platformServicesMasterData = get(action, 'payload.res.data', []);
        state.platformServicesMasterDataTotalCount = get(action, 'payload.res.total_count', 0);
        state.platformServicesMasterDataPageNumber = get(action, 'payload.res.page', 1);
      }
    },
    getServicesDataFailed: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.platformServicesMasterError = true;
      state.platformServicesMasterData = [];

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.error(message);
    },
    addServiceRequest: (state) => {
      state.isPlatformServicesMasterDataLoading = true;
      state.isAddServiceLoading = true;
      state.isAddServiceSuccess = false;
      state.isAddServiceError = false;
    },
    addServiceResponse: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isAddServiceLoading = false;
      state.isAddServiceSuccess = true;
      state.isAddServiceError = false;

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.success(message);
    },
    addServiceFailed: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isAddServiceLoading = false;
      state.isAddServiceError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.error(message);
    },
    updateServiceRequest: (state) => {
      state.isPlatformServicesMasterDataLoading = true;
      state.isUpdateServiceLoading = true;
      state.isUpdateServiceSuccess = false;
      state.isUpdateServiceError = false;
    },
    updateServiceResponse: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isUpdateServiceLoading = false;
      state.isUpdateServiceSuccess = true;
      state.isUpdateServiceError = false;

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.success(message);
    },
    updateServiceFailed: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isUpdateServiceLoading = false;
      state.isUpdateServiceError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.error(message);
    },
    removeServiceRequest: (state) => {
      state.isPlatformServicesMasterDataLoading = true;
      state.isRemoveServiceLoading = true;
      state.isRemoveServiceSuccess = false;
      state.isRemoveServiceError = false;
    },
    removeServiceResponse: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isRemoveServiceLoading = false;
      state.isRemoveServiceSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.platformMessage = message;
      Snackbar.success(message);
    },
    removeServiceFailed: (state, action: any) => {
      state.isPlatformServicesMasterDataLoading = false;
      state.isRemoveServiceLoading = false;
      state.isRemoveServiceError = true;

      const message = action.payload?.error;
      state.platformMessage = action.payload?.error;
      Snackbar.error(message);
    },
    resetLoadingState: (state) => {
      state.isUpdateServiceSuccess = false;
      state.platformServicesMasterError = false;
      state.isAddServiceLoading = false;
      state.isAddServiceSuccess = false;
      state.isAddServiceError = false;
      state.isUpdateServiceLoading = false;
      state.isUpdateServiceSuccess = false;
      state.isUpdateServiceError = false;
      state.isRemoveServiceLoading = false;
      state.isRemoveServiceSuccess = false;
      state.isRemoveServiceError = false;
      state.platformMessage = '';
    },
    resetPlatformServicesMasterData: (state) => {
      state.platformServicesMasterData = [];
      state.platformServicesMasterDataTotalCount = 0;
      state.platformServicesMasterDataPageNumber = 1;
      state.searchItem = '';
    },
    onSearchForItem: (state, action: SearchtActionTypes) => {
      state.searchItem = action.payload;
    },
  },
});

export const platformServicesMasterActions = platformServicesMasterReducer.actions;
export default platformServicesMasterReducer;
